module.exports = __webpack_public_path__ + "static/aasimar-1-8a41b13b1f3fc8c83233ad208fae9041.webp";